export default __webpack_public_path__ + "static/media/PowerGrotesk-LightItalic.a33a177c.otf";